<script>

    export default {
        alias: 'normalNotify',
        defaultOptions () {
            return {
                text: '提示',
                tpl: 'success'
            };
        },
        notifyCreated (options) {
            for (let key in options) {
                this[key] = options[key];
            }
            if (!this.okCallback) {
                this.hideDetail = true;
            }
            this.img = this.tipImg[this.tpl];
            this.option.durationDom = this.$el.querySelector('.duration');
            this.durtime();
        },
        data () {
            const tipTplInfo = {
                'success': {
                    content: '&#xe692;',
                    color: '#008af0'
                },
                'warn': {
                    content: '&#xe68e;',
                    color: '#fa4100'
                },
                'alert':{
                    content: '&#xe696;',
                    color: '#008AFE'
                }
            };
            return {
                hideDetail: false,
                tipImg: tipTplInfo,
                text: '',
                content: '',
                tpl: 'success',
                img: tipTplInfo['success'],
                option: {
                    duration: 0,
                    time: 3000,
                    freq: 30,
                    durationDom: null,
                    durationClock: null
                },
                hideClass: null
            };
        },
        name: 'normal-notify',
        methods: {
            durtime () {
                if (this.option.duration >= this.option.time) {
                    this.hide();
                } else {
                    this.option.duration += this.option.freq;
                    this.option.durationClock = setTimeout(this.durtime, this.option.freq);
                }
            },
            hide () {
                this.hideClass = 'hide';
                setTimeout(() => {
                    clearTimeout(this.option.durationClock);
                    this.close();
                }, 500);
            },
            gotoDetail () {
                this.okCallback && this.okCallback();
            }
        },
        components: {},
        mounted () {

        }
    };
</script>
<template>
    <div class="notify-area">
        <div class="notify-area__warp" @click.stop="gotoDetail;" :class="[tpl, hideClass]">
            <span class="notify-img-box" v-html="img.content" :style="{color: img.color}"></span>
            <div class="notify-area__body">
                <h2 class="notify-area__body-title">{{text}}</h2>
                <p class="notify-area__body-content" v-show="content" v-html="content"></p>
            </div>
            <span class="icon with-close" @click.stop="hide();">&#xe6a4;</span>
        </div>
    </div>
</template>

<style lang="less" scoped>
    @import '../../assets/less/widgets-var.less';

    .icon {
        font-family: cmsicon;
    }

    .with-close {
        margin-top: 5px;
        height: 16px;
    }

    .notify-area {
        position: fixed;
        z-index: 95000;
        right: 0;
        top: 84px;
        width: 100%;
        height: auto;
        min-height: 1px;
        pointer-events: none;
        padding-right: 4px;
        &__body {
            width: 100%;
            display: inline-block;
            margin-left: 13px;
            margin-top: 2px;

            &-content {
                padding-top: 10px;
                font-size: 14px;
                color: @otherTextClr;
            }

            &-title {
                width: auto;
                font-weight: 700;
                font-size: 16px;
                word-break: break-all;
                box-sizing: border-box;
                height: auto;
                line-height: 1.4;
                margin: 0;
            }
        }

        &__warp {
            box-sizing: border-box;
            clear: both;
            width: 310px;
            overflow: hidden;
            float: right;
            /*margin: 4px;*/
            padding: 20px;
            min-height: 55px;
            height: auto;
            font-size: 14px;
            /*backgroundd-color: #016dcc;*/
            box-shadow: 0 2px 7.68px 0.32px rgba(17, 6, 85, 0.16);
            border-radius: 5px;
            color: @otherNormalTitleClr;
            font-weight: 500;
            position: relative;
            transition: all ease-in 0.2s;
            transform: translateX(200%);
            display: flex;
            background-color: #fff;
            cursor: pointer;

            p {
                margin: 0;
            }

            &.warn {
                /*background-color: #e84142;*/
            }

            &.success {
                /*background-color: #016dcc;*/
            }

            &.show {
                -webkit-transform: translateX(0);
                -moz-transform: translateX(0);
                -ms-transform: translateX(0);
                transform: translateX(0);
                pointer-events: auto;

                > .duration {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    height: 55px;
                    background-color: rgba(255, 255, 255, 0.1);
                    width: 100%;
                }
            }

            > &:hover {
                background-color: #555;
                color: #fff;
                cursor: pointer;
            }

            &.hide {
                -webkit-transform: scale(1, 0);
                -moz-transform: scale(1, 0);
                -ms-transform: scale(1, 0);
                /*transform: scale(1, 0);*/
                transform: translateX(200%);
            }

            .notify-img-box {
                font-family: cmsicon;
                height: 24px;
                width: 24px;
                font-size: 24px;
            }

            .notify-img {
                margin-top: -3px;
                width: 30px;
                height: auto;
                vertical-align: middle;
                font-family: cmsicon;
                font-size: 22px;
            }

            .notify-detail {
                vertical-align: middle;
                width: 40px;
                height: auto;
                min-height: 30px;
                font-weight: normal;
                text-align: right;
                border-left: 1px solid @otherBorderClr;

                &.hideDetail {
                    border-left: none;
                    visibility: hidden;
                }
            }
        }
    }


</style>
